import { Typography } from "@ster/ster-toolkit";
import classNames from "classnames";
import React, { useCallback } from "react";
import { useRecoilState, useRecoilValue } from "recoil";

import AddConversionGroup from "./AddConversionGroup";
import {
  calculateState,
  campaignsForCalculateState,
  conversionGroupsState,
  metadataState,
} from "./atoms";
import { Campaign } from "./Compare";
import ResultItem from "./ResultItem";
import styles from "./Results.module.less";

const ResultsLabels = ({
  campaigns,
  medium,
}: {
  campaigns: Partial<Campaign>[];
  medium: string;
}): JSX.Element | null => {
  const [conversionGroups, setConversionGroups] = useRecoilState(
    conversionGroupsState
  );
  const metadata = useRecoilValue(metadataState(medium));

  const results = useRecoilValue(
    calculateState({
      campaigns: useRecoilValue(campaignsForCalculateState),
      conversionGroups: useRecoilValue(conversionGroupsState).map(
        (s) => s.value
      ),
      medium,
    })
  );

  const handleDeleteConversionGroup = useCallback(
    (label: string) => {
      setConversionGroups(conversionGroups.filter((c) => c.label !== label));
    },
    [conversionGroups, setConversionGroups]
  );

  if (!results) {
    return null;
  }

  return (
    <>
      <div className={styles.title}>
        <Typography.Title level={3}>Doelgroepen</Typography.Title>
      </div>

      <AddConversionGroup campaigns={campaigns} medium={medium} />

      <div className={styles.conversionGroups}>
        <div className={classNames(styles.container, styles.onlyLabels)}>
          {results.conversionGroups?.map((r) => (
            <ResultItem
              result={r}
              campaigns={campaigns}
              key={JSON.stringify(r)}
              onDelete={handleDeleteConversionGroup}
              onlyLabels
              metadata={metadata}
            />
          ))}
        </div>
      </div>

      <div
        className={classNames(styles.onlyLabels, {
          [styles.container]: (results.targetGroups?.length ?? 0) > 0,
        })}
      >
        {results.targetGroups?.map((r) => (
          <ResultItem
            result={r}
            campaigns={campaigns}
            key={r.targetGroupName}
            onlyLabels
          />
        ))}
      </div>
    </>
  );
};

export default ResultsLabels;
